/**
 * @(#)2019/11/11.
 * YxUpload，控制预览
 * @author 足道
 * Copyright (c) 2019, YUNXI. All rights reserved.
 * YUNXI PROPRIETARY/CONFIDENTIAL. Use is subject to license terms.
 */

import React from "react";
import styles from "./preview.less";
import YxModal from "../../../YxModal";
import YxOffice from "../../../YxOffice";
import { YxComponent } from "../../../YxComponent";
import { get, merge, nodeFactory } from "../../../../utils/index";

class UploadPreview extends YxComponent {
  constructor(props, context) {
    super(props, context);
  }

  get previewType() {
    const type = get(this.props, "type", "img");
    const fileType = get(this.props, "showType", type);
    const previewType = get(this.props, "previewType", fileType);
    return previewType;
  }

  get previewUrl() {
    const visible = get(this.props, "visible", false);
    if (visible) {
      return get(this.props, "url", "");
    }
    return null;
  }

  onCancel = () => {
    get(this.props, "onCancel", () => {})();
  };

  get modalParam() {
    const type = this.previewType;
    return {
      className: [
        styles["upload_preview"],
        type === "office" ? "yx_office_modal" : "",
      ].join(" "),
      footer: null,
      onCancel: this.onCancel,
      visible: get(this.props, "visible", false),
    };
  }

  renderContent = () => {
    const type = this.previewType;
    const uploadPreview = nodeFactory(
      get(this.props, "uploadPreview", null),
      this.props
    );
    if (uploadPreview != null) {
      return uploadPreview;
    } else {
      const baseParam = {
        alt: "",
        src: this.previewUrl,
        className: "modal_content",
      };
      if (["img", "imgs", "image"].includes(type)) {
        return <img {...baseParam} />;
      } else if (type === "video") {
        return <video {...baseParam} controls preload></video>;
      } else if (type === "office") {
        return <YxOffice {...baseParam} />;
      }
    }
  };

  render() {
    const visible = get(this.props, "visible", false);
    return (
      <YxModal {...this.modalParam}>{visible && this.renderContent()}</YxModal>
    );
  }
}

export default UploadPreview;



// WEBPACK FOOTER //
// ./src/yx-widget/component/YxInput/YxUpload/Components/UploadPreview.js